function initialState() {
  return {
    VehicleTurnPredictorModal: {
      ShowModal: false,
      EntityId: null,
      vehicleTurnPrediction: null,
    },
  };
}

const state = initialState();

const getters = {
  VehicleTurnPredictorModal: function(state) {
    return state.VehicleTurnPredictorModal;
  },
};

const actions = {
  openVehicleTurnPredictorModal(context, data) {
    context.commit("openVehicleTurnPredictorModal", data);
  },
  closeVehicleTurnPredictorModal(context) {
    context.commit("closeVehicleTurnPredictorModal");
  },
};

const mutations = {
  openVehicleTurnPredictorModal(state, data) {
    state.VehicleTurnPredictorModal.ShowModal = true;
    state.VehicleTurnPredictorModal.EntityId = data.entityId;
    state.VehicleTurnPredictorModal.vehicleTurnPrediction = data.vehicleTurnPrediction;
  },
  closeVehicleTurnPredictorModal(state) {
    state.VehicleTurnPredictorModal.ShowModal = false;
    state.VehicleTurnPredictorModal.EntityId = null;
    state.VehicleTurnPredictorModal.vehicleTurnPrediction = null;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customerdashboard/VehicleTurnPredictor.js